import { formStateDescription, type FormStateId } from '#types';

const id: keyof typeof formStateDescription = 'draft';

/** `FormStateId` for a new in-progress version row (e.g. "New draft version"). */
export const draftFormStateId: FormStateId = id;
